import EstadosLeyenda, { EstadoLeyenda } from "../shared/EstadosLeyenda.tsx";

// Informative only: meaning of each purchase order state, with the same
// colors the table uses (CSS variables in utils/main.css)
const ESTADOS: EstadoLeyenda[] = [
  {
    nombre: "Pendiente",
    color: "var(--color-pendiente)",
    texto: "Orden creada.",
  },
  {
    nombre: "Aprobada",
    color: "var(--color-aprobadas)",
    texto:
      "La orden ha sido aprobada por la subgerencia responsable del presupuesto.",
  },
  {
    nombre: "Confirmada",
    color: "var(--color-confirmadas)",
    texto:
      "La orden ha sido confirmada por la Subgerencia de Administración y Finanzas.",
  },
  {
    nombre: "Pendiente GG",
    color: "var(--color-pendientes-gte)",
    texto:
      "Orden confirmada por la Subgerencia de Administración y Finanzas, pero requiere aprobación de la Gerencia General.",
  },
  {
    nombre: "Confirmada GG",
    color: "var(--color-confirmadas-gte)",
    texto: "La orden ha sido confirmada por la Gerencia General.",
  },
  {
    nombre: "Rechazada",
    color: "var(--color-rechazadas)",
    texto: "La orden no ha sido aprobada.",
  },
  {
    nombre: "Anulada",
    color: "var(--color-anuladas)",
    texto: "La orden ha sido cerrada por errores o duplicidad.",
  },
];

const PARCIALES: EstadoLeyenda[] = [
  { nombre: "Aprobada parcialmente", color: "var(--color-aprobadas-parcial)" },
  {
    nombre: "Rechazada parcialmente",
    color: "var(--color-rechazadas-parcial)",
  },
  {
    nombre: "Confirmada parcialmente",
    color: "var(--color-confirmadas-parcial)",
  },
];

export default function EstadosOrdenLeyenda() {
  return (
    <EstadosLeyenda
      titulo="Estados de la orden"
      estados={ESTADOS}
      parciales={PARCIALES}
      textoParciales="Estados parciales: las líneas de detalle de la orden quedaron en estados distintos (por ejemplo, algunas aprobadas y otras pendientes o rechazadas). Revisa el estado de cada línea en el detalle de la orden."
    />
  );
}
